import { Box, Typography } from '@material-ui/core';
import { StandardDialog, Button, ConfirmationButton, DateField, } from '@roc/ui';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useInterestAllocationStore } from '@roc/feature-payoffs';
import RichTextWithAttachments from 'libs/feature-backoffice-users/src/backOfficeUsers/utils/richTextWithAttachments';
import { usePayoffRequestStore } from '@roc/feature-loans';
import moment from "moment";
import { format, isValid } from "date-fns";


interface IRequestRevisionsProps {
  loanId: number;
  payoffId: number;
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: '8px'
  },
}));

export const RequestRevisionsDialog = observer(({ loanId, payoffId, open, onClose }: IRequestRevisionsProps) => {
  const classes = useStyles();
  const { payoffRequestStore } = usePayoffRequestStore();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  useEffect(() => {
    const requestedDate = payoffRequestStore.selectedPayoff?.requestedDate;
    if (open && requestedDate) {
      setSelectedDate(new Date(requestedDate.toString()));
    }
  }, [open])

  const onSubmit = async () => {
    await payoffRequestStore.updateRequestedDate(loanId, payoffRequestStore.selectedPayoffId, selectedDate.toString());
    onClose();
  }

  const onDateChange = (newValue) => {
    setSelectedDate(newValue)
  }
  const manageDate = (value) => {
    const formattedDate = isValid(value) ? format(value, 'MM/dd/yyyy') : null;
    onDateChange(formattedDate);
  };

  const getContent = () => {
    return (
      <Box display="flex" justifyContent={"center"} flexDirection="column" height="100%" width="100%">
        <Typography variant="subtitle1">
          New requested Date:
        </Typography>
        <DateField
          inputVariant="outlined"
          format="MM/dd/yyyy"
          testId='requested-date-input'
          value={selectedDate}
          onChange={value => manageDate(value)}
          disablePast={true}
          fullWidth
        />
      </Box>
    )
  }

  return (
    <StandardDialog
      open={open}
      title={"Request Revisions"}
      maxWidth="sm"
      handleClose={onClose}
      dialogContent={
        getContent()
      }
      dialogActions={(
        <>
          <Box mr={2}>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={onClose}
              testId="close"
            >
              CLOSE
            </Button>
            <ConfirmationButton
              onClick={onSubmit}
              color="primary"
              variant="contained"
              testId="confirm"
              confirmDialogProps={{
                title: 'Confirmation',
                body:
                  'Are you sure you want to request revisions for this payoff?',
              }}
            >
              SUBMIT
            </ConfirmationButton>
          </Box>
        </>
      )}
    />
  );
});